module.exports = {
  extensionId: 'brand-theme'
}
